export default __webpack_public_path__ + "static/media/logo-trustpilot-1-0-stars.27387326.svg";